import React, { useState } from 'react';
import {connect} from "trim-redux";
import { Styles } from '../../../config/design/styles';
import validator from 'validator';
import axios from 'axios';
import {Checkbox, FormControlLabel, InputAdornment, Typography} from "@mui/material";
import Grid from '@mui/material/Grid2';
import LoadingButton from "../../components/elements/LoadingButton";
import {Link, useNavigate} from "react-router-dom";
import PassField from "../../components/elements/fields/PassField";
import { defaultVariables } from "../../../config";
import { withStyles } from "@mui/styles";
import {useSnackbar} from "notistack";
import {updateRedux} from "../../../config/Security";
import {useTranslation} from "react-i18next";
import RayaField from "../../components/elements/fields/RayaField";
import PrivacyPolicyButton from "../../components/elements/PrivacyPolicyButton";
import TermsButton from "../../components/elements/TermsButton";
import Tooltip from "@mui/material/Tooltip";
import {BadgeCheck} from "lucide-react";
import MobileField from "../../components/elements/fields/MobileField";

const Register = (props) => {
    const navigation = useNavigate();
    const [fields, setFields] = useState({
        first_name: '',
        last_name: '',
        birthdate: "",
        mobile: props.user?.mobile ?? '',
        country: null,
        password: '',
        password_confirmation: ''
    });
    const { t } = useTranslation();

    const { enqueueSnackbar } = useSnackbar();
    const [errors, setErrors] = useState({});
    const [hasPass, setHasPas] = useState(false);
    const [confirmed, setConfirmed] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);
    const [disableMobile, setDisableMobile] = useState(!!props.user?.mobile);

    const handleChange = (e) => {
        const { name, value } = e.target;
        let newFields = { ...fields };
        let newErrors = { ...errors };
        newErrors[name] = "";
        newFields[name] = value;
        setFields(newFields);
        setErrors(newErrors);
    };
    const setMobileField = (country, mobile) => {
        setFields((prevFields) => ({
            ...prevFields,
            country,
            mobile
        }));
        setErrors((prevErrors) => ({ ...prevErrors, mobile: '' }));
    };
    const handleValidation = async (callback) => {
        let newErrors = {};
        let formIsValid = true;

        // Full name
        if (validator.isEmpty(fields.first_name)) {
            formIsValid = false;
            newErrors['first_name'] = t('emptyField');
        }
        if (validator.isEmpty(fields.last_name)) {
            formIsValid = false;
            newErrors['last_name'] = t('emptyField');
        }
        // Validation for mobile
        if (validator.isEmpty(fields.mobile)) {
            formIsValid = false;
            newErrors.mobile = t('emptyField');
        }else if(fields.mobile.length < 9 ){
            formIsValid = false;
            newErrors.mobile = t('wrongMobile');
        }
        // Password
        if (validator.isEmpty(fields.password)) {

        } else if (fields.password.length < 5) {
            formIsValid = false;
            newErrors['password'] = t('weakPassword');
        }
        /*// Password confirmation
        if (validator.isEmpty(fields.password_confirmation)) {
            formIsValid = false;
            newErrors['password_confirmation'] = t('emptyField');
        } else if (fields.password_confirmation !== fields.password) {
            formIsValid = false;
            newErrors['password_confirmation'] = t('noMatchPassword');
        }*/
        if(!confirmed){
            formIsValid = false;
            newErrors['confirmed'] = t('setConfirmedError');
        }
        if(!!formIsValid){
            // API check for email and mobile
            const data = new FormData();
            if(!disableMobile && fields.mobile && fields.country){
                let mobile = Number(fields.mobile).toString();
                mobile = fields.country?.phonecode+mobile;
                data.append("mobile", mobile);
            }
            data.append('user_id', props.user?.id);

            const loginToken = localStorage.getItem('ACT');
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`
                }
            };

            try {
                const response = await axios.post(`${defaultVariables.url}/auth/check-info`, data, config);
                const apiErrors = response.data.errors;
                if (apiErrors.mobile) {
                    formIsValid = false;
                    newErrors.mobile = apiErrors.mobile[0];
                }
            } catch (error) {
                console.error(error);
            }
        }
        setErrors(newErrors);
        callback(formIsValid);
    };

    const handleRequest = async () => {
        const { first_name,last_name, birthdate, password, password_confirmation, role, name } = fields;
        let data = new FormData();
        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        data.append('first_name', first_name);
        data.append('last_name', last_name);
        data.append('birthdate', birthdate);
        data.append('password', password);
        // data.append('c_password', password_confirmation);
        if(!disableMobile){
            let mobile = Number(fields.mobile).toString();
            if(mobile.length > 3){
                mobile = fields.country?.phonecode+mobile;
                data.append("mobile", mobile);
                data.append("code", fields.country?.phonecode);
            }
        }
        try {
            const response = await axios.post(`${defaultVariables.url}/auth/register-step`, data, config);
            await updateRedux();
            navigation('/');
        } catch (error) {
            console.log(error.response);
            setSubmitLoading(false);
            enqueueSnackbar(t('registerError'), {
                variant: 'error',
            });
        }
        
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setSubmitLoading(true);
        handleValidation((valid) => {
            if (valid) {
                handleRequest();
            }else{
                setSubmitLoading(false);
            }
        });
    };

    const { classes } = props;

    return (
            <form className={classes.form} noValidate onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <RayaField
                            fullWidth
                            variant="outlined"
                            label={t('first_name')}
                            name="first_name"
                            autoFocus
                            onChange={handleChange}
                            error={!!errors['first_name']}
                            helperText={errors['first_name']}
                            color="violet"
                        />
                    </Grid>
                    <Grid item size={{ xs: 12, md: 6 }}>
                        <RayaField
                            fullWidth
                            variant="outlined"
                            label={t('last_name')}
                            name="last_name"
                            onChange={handleChange}
                            error={!!errors['last_name']}
                            helperText={errors['last_name']}
                        />
                    </Grid>
                    <Grid item size={{xs:12}}>
                        {
                            !!disableMobile ?
                                <>
                                    <RayaField
                                        variant="outlined"
                                        required
                                        fullWidth
                                        label={t('mobile')}
                                        name="mobile"
                                        value={fields.mobile}
                                        error={!!errors.mobile}
                                        helperText={errors.mobile}
                                        disabled
                                    />
                                </>

                                :
                                <MobileField
                                    setMobile={setMobileField}
                                    error={errors['mobile']}
                                />
                        }
                    </Grid>
                    <Grid item size={{ xs: 12 }}>
                        <RayaField
                            fullWidth
                            variant="outlined"
                            value={fields.birthdate}
                            label={t('birthdate')}
                            name="birthdate"
                            type="date"
                            onChange={handleChange}
                            error={!!errors['birthdate']}
                            helperText={errors['birthdate']}
                        />
                    </Grid>
                    <Grid item size={{ xs: 12 }}>
                        <FormControlLabel
                            label={t('setPassword')}
                            control={<Checkbox checked={hasPass} onChange={() => setHasPas(!hasPass)} />}
                        />
                    </Grid>
                    {
                        !!hasPass &&
                        <Grid item size={{ xs: 12 }} style={{marginBottom:15}}>
                            <PassField
                                fullWidth
                                variant="outlined"
                                name="password"
                                label={t('password')}
                                type="password"
                                onChange={handleChange}
                                error={!!errors['password']}
                                helperText={errors['password']}
                            />
                        </Grid>
                    }

                    {/*<Grid item size={{ xs: 12, md: 6 }}>
                        <PassField
                            required
                            variant="outlined"
                            fullWidth
                            name="password_confirmation"
                            label={t('passwordConfirm')}
                            placeholder={t('passwordConfirm')}
                            type="password"
                            onChange={handleChange}
                            error={!!errors['password_confirmation']}
                            helperText={errors['password_confirmation']}
                        />
                    </Grid>*/}
                </Grid>
                <Grid item size={{ xs: 12 }}>
                    <FormControlLabel
                        label={
                            <Typography>{t('setConfirmed')} <PrivacyPolicyButton/> {t('setConfirmed3')} <TermsButton/> {t('setConfirmed4')}</Typography>
                        }
                        control={<Checkbox checked={confirmed} onChange={() => setConfirmed(!confirmed)} />}
                    />
                    {
                        !!errors['confirmed'] &&
                        <Typography className="error-text">{errors['confirmed']}</Typography>

                    }
                </Grid>
                <Grid item xs={12}>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        size="large"
                        loading={submitLoading}
                        style={{width:"100%"}}
                        styleForParent={{marginBottom:0}}
                    >
                        {t('continue')}
                    </LoadingButton>
                </Grid>
            </form>
    );
};

const mstp = (state) => ({
    isAuth: state.isAuth,
    user: state.user,
    locale: state.locale,
});

export default withStyles(Styles)(connect(mstp)(Register));
